import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Observable, of } from 'rxjs';

import { map } from 'rxjs/operators';

import { CommonApiService } from '../../proxy/services/common-api.service';
import { EntityType } from '../../proxy/models/entity-type.enum';
import { GlobalConfig } from '../../proxy/models/common';
import { IndexDbKeys } from '../../proxy/models/index-db-keys';
import { IndexDbService } from './indexDb.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalConfigsService {
  private globalConfigsSignal = signal<GlobalConfig[]>([]);
  private platformId = inject(PLATFORM_ID);
  private indexDbService = inject(IndexDbService);
  private commonApiService = inject(CommonApiService);

  public getConfigs(): Observable<GlobalConfig[]> {
    return this.indexDbService.getByKey(IndexDbKeys.ConfigChecksum).pipe(
      map((data: any) => {
        return data ? data.value : null;
      }),
    );
  }

  public setConfigs(value: GlobalConfig[]) {
    this.globalConfigsSignal.set(value);
  }

  public removeConfigs(): void {
    this.indexDbService.removeByKey(IndexDbKeys.ConfigChecksum);
  }

  public configs(): GlobalConfig[] {
    return this.globalConfigsSignal();
  }

  public getConfigsApi() {
    if (isPlatformBrowser(this.platformId)) {
      const emptyGUID = EntityType.emptyGUID;

      const data = {
        __type: 'GlobalConfiguration:#Avion.Genesis.Avalon.Core',
        EntityTypeId: EntityType.globalConfiguration,
        Description: '',
        DisplayId: 0,
        EntityId: emptyGUID,
        OwnerEntityId: emptyGUID,
        OwnerEntityTypeId: '',
      }
      return this.commonApiService.readAll<GlobalConfig>(data);
    }
    return of(true);
  }
}
